import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { isAuthenticated } from '@/Config/auth/authStore';

export const SessionExpiredRedirect = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('auth');
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (hasRedirected.current) return;
    hasRedirected.current = true;

    // An authenticated user landing here is a routing miss (usually a legacy
    // URL like /i/{scenario}/dashboard), not an expired session. A full reload
    // of `/` lets Django's index() redirect into their current scenario;
    // navigate('/') instead would render the login form inside the
    // authenticated tree, where reCAPTCHA is absent and submit is a no-op.
    if (isAuthenticated()) {
      window.location.replace('/');
      return;
    }

    toast.info(t('session_expired'));
    navigate('/', { replace: true });
  }, [navigate, t]);

  return null;
};
